import CityPageTemplate from "../city-template/CityPageTemplate";
import { aspenConfig } from "./data";

export default function AspenPage() {
  return <CityPageTemplate config={aspenConfig} />;
}